/**
 * Shared chip styling — the single source of truth for any chip in the app.
 *
 * Consumers render chips as:
 *
 *   <div class="app-chip-item">
 *     <p-chip class="app-chip" [label]="…" [removable]="true" (onRemove)="…" />
 *   </div>
 *
 * The chip carries its OWN spacing (font-size, vertical breathing, border radius,
 * label wrapping). Containers just need to lay out their children — they don't need
 * to apply chip-specific padding/gap themselves. Drop the pattern in anywhere and
 * it just works.
 */
export const styles = () => `.app-chip-item {
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 14px;
}

/* Optimus ships per-parent border-radius overrides (e.g. .p-multiselect .p-chip)
   that win on specificity over a generic class rule. !important forces the
   single shared radius regardless of where the chip is rendered.
   padding-block gives every chip the multiselect's vertical rhythm (0.25rem): inside a
   multiselect Optimus already sets this via .p-multiselect-label .p-chip (a tie at 0.25rem,
   so no change there), but a bare .p-chip (treeselect lane, standalone chips) defaults to
   0.5rem — .app-chip.p-chip (0,2,0) outranks base .p-chip (0,1,0), so the chip carries its
   own height and is identical everywhere. No !important needed for padding-block. */
.app-chip.p-chip {
  border-radius: 0.375rem !important;
  padding-block: 0.25rem;
}

.app-chip .p-chip-label {
  white-space: normal;
  word-break: break-word;
}

/* Tree-select trigger chip lane: our treeselect trigger's chip lane is a bare flex
   container, so reproduce exactly how Optimus lays out multiselect chips on
   .p-multiselect-label — the HALVED form-field paddings: gap calc(padding.y/2)=0.25rem
   between chips plus the full :has(.p-chip) inset calc(padding.y/2) calc(padding.x/2)
   = 0.25rem 0.375rem (vertical + horizontal), so chips get top/bottom breathing too,
   not just the horizontal edge inset. (Specificity beats the template's Tailwind
   .gap-1.) One place, every tree-select. */
.app-treeselect .treeselect-button .flex.flex-wrap {
  gap: 0.25rem;
  padding: 0.25rem 0.375rem;
}
`;
